const unityConfig = {
  // Base URL from where Unity build files will be served
  baseUrl: process.env.REACT_APP_UNITY_BASE_URL || '',
  
  // Game product info
  productInfo: {
    companyName: "maveragames",
    productName: "Fried Chicken Royale",
    productVersion: "3.5.0",
  },
  
  // Unity build files (these will be automatically updated by the copy script)
  buildFiles: {
    loaderHash: "4a033c8810812a0567a1b7de4828660b",
    dataHash: "2091cff37e50c201959bdfa27711cda1",
    frameworkHash: "60ab1e6e52a3a601b1bab5a23cce8d60",
    wasmHash: "5cee061c67b535a76819fb3338d38ec2",
  },
  
  // Disable Unity caching to prevent issues with hosting services
  disableUnityCache: true,
  
  // Canvas dimensions for desktop (mobile will be responsive)
  canvasDimensions: {
    width: 540,
    height: 960
  }
};

export default unityConfig; 